import './index.css'

const Tags = props => {
  const {tagDetails, onclickTag, activeTag} = props
  const {displayText, optionId} = tagDetails

  const buttonClass = activeTag === optionId ? 'tagBtn active' : 'tagBtn'

  return (
    <li className="tagList">
      <button
        type="button"
        className={buttonClass}
        onClick={() => onclickTag(optionId)}
      >
        {displayText}
      </button>
    </li>
  )
}

export default Tags
